import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/knowledge")({
  beforeLoad: () => {
    throw redirect({ to: "/en/admin/knowledge", replace: true });
  },
});
